const a = {
  diagnose: {
    key: "diagnose",
    path: "/diagnose",
    value: "Diagnose"
  },
  history: {
    key: "history",
    path: "/history",
    value: "History"
  }
};
export {
  a as default
};
